<template>
    <v-container class="pa-0 mx-0">
        <v-row class="ma-0" align="center" :style="'min-height: 100vh; background:url(/files/login-' + $vuetify.theme.name + '.png); background-repeat: no-repeat; background-size: cover;'">
            <div class="ma-auto">
                <v-row class="ma-0 mb-4">
                    <v-spacer/>
                    <img :src="'/files/logo-' + $vuetify.theme.name + '.png'" width="80px" class="mb-2"/>
                    <v-spacer/>
                </v-row>
                <v-card class="pa-12 pt-8 pb-8" elevation="8" rounded="lg" max-width="600">
                    <div class="text-center mb-8">
                        <v-card-title class="px-0">¿Olvidaste tu contraseña?</v-card-title>
                        <v-card-subtitle class="px-0" style="white-space: normal;">Ingresa el correo electrónico asociado a tu cuenta y te enviaremos instrucciones para restablecerla.</v-card-subtitle>
                    </div>
                    <v-form @submit.prevent="recoverPassword">
                        <v-text-field v-model="email" variant="solo-filled" label="Email"></v-text-field>
                        <v-btn type="submit" color="primary" block style="text-transform:none;">Recuperar Contraseña</v-btn>
                    </v-form>
                    <v-card-subtitle class="mt-6" style="text-align:center;">
                        <a class="text-decoration-none" href="/login" rel="noopener noreferrer">Iniciar Sesión</a>
                    </v-card-subtitle>
                </v-card>
            </div>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useAuthStore } from '@/store/auth';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'ForgotPassword',
  setup() {
    const authStore = useAuthStore();
    const email = ref('');
    const response = ref('');
    const router = useRouter();
    const recoverPassword = async () => {
      const request = await authStore.recoverPassword(email.value);
        
      if (request.success) {
        response.value = request.data || 'Login failed. Please check your credentials.';
      }else{
        response.value = request.error || 'Login failed. Please check your credentials.';
      }
    };

    return {
      email,
      recoverPassword
    };
  },
})
</script>

<style>

</style>